import { FC } from "react";
import { Box, makeStyles, TableCell } from "@material-ui/core";
import {
  ArrowDropDown as ArrowDropDownIcon,
  ArrowDropUp as ArrowDropUpIcon,
} from "@material-ui/icons";

import theme, { Theme } from "theme";

const sortArrowSize = {
  height: theme.spacing(4),
  width: theme.spacing(3),
};
const SortArrows: FC<{ isSortingAsc: boolean }> = ({ isSortingAsc }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      height={sortArrowSize.height}
      width={sortArrowSize.width}
    >
      <ArrowDropUpIcon
        style={{
          color: isSortingAsc
            ? theme.custom.palette.purple.main
            : theme.custom.palette.purple.lighter,
          marginBottom: theme.spacing(-1),
        }}
      />
      <ArrowDropDownIcon
        style={{
          color: !isSortingAsc
            ? theme.custom.palette.purple.main
            : theme.custom.palette.purple.lighter,
          marginTop: theme.spacing(-1),
        }}
      />
    </Box>
  );
};

const useHeaderCellStyles = makeStyles<Theme, { width: string }>({
  root: {
    color: theme.custom.palette.gray.darker,
    fontWeight: theme.typography.fontWeightLight,
    "&:hover": { cursor: "pointer" },
    padding: "6px 16px",
    position: "relative",
    width: props => props.width,
    "&::before": {
      content: "''",
      position: "absolute",
      top: "50%",
      height: "30%",
      right: "0px",
      width: "0.5px",
      transform: "translateY(-50%)",
      backgroundColor: theme.custom.palette.gray.dark,
    },
    "&:nth-last-child(2)::before": {
      display: "none",
    },
    "&::after": {
      content: "''",
      position: "absolute",
      top: "50%",
      height: "30%",
      left: "0px",
      width: "0.5px",
      transform: "translateY(-50%)",
      backgroundColor: theme.custom.palette.gray.dark,
    },
    "&:first-child::after": {
      display: "none",
    },
  },
});

const HeaderCell: FC<{
  isSorting: boolean;
  isSortingAsc: boolean;
  title: string;
  width: string;
  onClick: () => void;
}> = ({ isSorting, isSortingAsc, title, width, onClick }) => {
  const classes = useHeaderCellStyles({ width });
  return (
    <TableCell className={classes.root} onClick={onClick}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        {title}
        {isSorting ? (
          <SortArrows isSortingAsc={isSortingAsc} />
        ) : (
          <Box height={sortArrowSize.height} width={sortArrowSize.width} />
        )}
      </Box>
    </TableCell>
  );
};

export default HeaderCell;
